/**
 *  Keywords constant module file
**/

export const MODULE_NAME = 'keywords'

export const ACTIONS = {
}

export const GETTERS = {
  GET_SELECTED_ITEMS: 'GET_SELECTED_ITEMS'
}

export const MUTATIONS = {
  RESET_TREE: 'RESET_TREE',
  SET_SELECTED: 'SET_SELECTED',
  SET_CHILDREN: 'SET_CHILDREN'
}
